import { buildSectionSelector, normalizeSectionId, sectionRenderer } from '@theme/section-renderer';
import { requestIdleCallback, onDocumentReady } from '@theme/utilities';

const onecheckRedirects = new Map([
  ['/products/明治製薬-k', '/products/meiji-iyaku-antigen-test-kit-research-1p'],
  ['/products/meiji-iyaku-antigen-test-kit-research', '/products/meiji-iyaku-antigen-test-kit-research-1p'],
  ['/products/meiji-iyaku-antigen-test-kit-1p-research', '/products/meiji-iyaku-antigen-test-kit-research-1p'],
  [
    '/products/新型コロナウイルス-インフルエンザa-b-抗原検査キット-ko316-rabliss',
    '/products/rabliss-ko316-antigen-test-kit-research',
  ],
]);

function getDecodedPathname() {
  try {
    return decodeURIComponent(window.location.pathname);
  } catch {
    return window.location.pathname;
  }
}

function setMetaContent(selector, content) {
  const element = document.head.querySelector(selector);
  if (element) {
    element.setAttribute('content', content);
  }
}

function applyOnecheckSeoFallbacks() {
  const decodedPathname = getDecodedPathname();
  const redirectTarget = onecheckRedirects.get(decodedPathname);

  if (redirectTarget) {
    window.location.replace(`${redirectTarget}${window.location.search}${window.location.hash}`);
    return;
  }

  if (window.location.pathname === '/' || window.location.pathname === '') {
    const title = 'onecheck.jp｜研究用抗原検査キット コロナ・インフルA/B';
    const description =
      'onecheck.jpは、新型コロナウイルス・インフルエンザA/B抗原検査キット（研究用）を扱うオンラインストアです。RABLISS、明治医薬などを掲載。診断目的には使用できません。';

    document.title = title;
    setMetaContent('meta[name="description"]', description);
    setMetaContent('meta[property="og:title"]', title);
    setMetaContent('meta[property="og:description"]', description);
    setMetaContent('meta[name="twitter:title"]', title);
    setMetaContent('meta[name="twitter:description"]', description);
  }
}

applyOnecheckSeoFallbacks();

/**
 * Hydrates a section using the Section Rendering API preserving states.
 * Only updates elements with data-hydration-key attribute. This ensures that non-targeted nodes do not have their markup/state updated unnecessarily.
 *
 * @param {string} sectionId - The section ID to hydrate
 * @param {URL} [url] - The URL to render the section from
 */
async function hydrateSection(sectionId, url) {
  const normalizedId = normalizeSectionId(sectionId);
  const section = document.getElementById(buildSectionSelector(normalizedId));

  if (!section || section.dataset.hydrated === 'true') {
    return;
  }

  await sectionRenderer.renderSection(normalizedId, { cache: false, url, mode: 'hydration' });

  section.dataset.hydrated = 'true';
}

/**
 * Hydrates a section using the Section Rendering API preserving states, when
 * the DOM is ready.
 *
 * @param {string} sectionId - The section ID to hydrate
 * @param {URL} [url] - The URL to render the section from
 */
export async function hydrate(sectionId, url) {
  onDocumentReady(() => {
    requestIdleCallback(() => hydrateSection(sectionId, url));
  });
}
